import styled from "styled-components";

export const ModalContainer = styled.div`
  .errorMessage {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    margin-top: 16px;
    background-color: #ffebee;
    color: #d32f2f;
    border-radius: 4px;

    svg {
      flex-shrink: 0;
    }
  }

  .uploadArea {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 180px;
    border: 2px dashed ${({ theme }) => theme.colors.gray};
    border-radius: 4px;
    margin-top: 16px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
      border-color: ${({ theme }) => theme.colors.primary};
      background-color: rgba(0, 0, 0, 0.02);
    }

    svg {
      color: ${({ theme }) => theme.colors.primary};
      margin-bottom: 16px;
    }
  }

  .selectedFile {
    text-align: center;
  }

  .helpText {
    margin-top: 8px;
    color: ${({ theme }) => theme.colors.gray};
  }
`;
